<template>
  <div class="goodsTable">
    <el-tabs v-model="goodsInfoActiveTab" type="card">
      <el-tab-pane :label="$t('OrdinaryOrderMix.GoodsInfoTab.Summarize')" name="sku">
        <SkuList
          v-if="goodsInfoActiveTabHistory.has('sku')"
          ref="SkuList"
          :order-id="orderId"
          :has-btn="hasBtn"
          :business-type="businessType"
          @afterFetchOriginalData="afterFetchOriginalData"
        />
      </el-tab-pane>
      <el-tab-pane :label="$t('OrdinaryOrderMix.GoodsInfoTab.product')" name="skuItem">
        <SkuLineList
          v-if="goodsInfoActiveTabHistory.has('skuItem')"
          ref="SkuLineList"
          :order-id="orderId"
          :has-btn="hasBtn"
          :business-type="businessType"
        />
      </el-tab-pane>
      <!-- 包材信息 -->
      <el-tab-pane :label="$t('goodsPage.package.Info')" name="package" v-if="this.$store.state.user.permissionBtns.includes('BusinessGoodsPackageManagement'.toLocaleLowerCase())">
        <el-table :data="PackageVOList" :border="true" :header-cell-style="$rowStyle.DEFAULT">
          <el-table-column :label="$t('table.countText')" type="index" width="55" align="center" />
          <el-table-column prop="packingMethod" :label="$t('goodsPage.packingM')" show-overflow-tooltip align="center">
              <template slot-scope="scope">{{ $t(PACKAGE_TYPE_LIST.bjGet(scope.row.packingMethod)) }}</template>
          </el-table-column>
          <el-table-column prop="name" :label="$t('goodsPage.package.Name')" show-overflow-tooltip align="center" />
          <el-table-column prop="sku" :label="$t('goodsPage.package.SKU')" show-overflow-tooltip align="center" />
          <el-table-column prop="qty" :label="$t('goodsPage.package.num')" show-overflow-tooltip align="center">
              <template slot-scope="scope">{{ scope.row.qty }}</template>
          </el-table-column>
          <el-table-column prop="materialFee" :label="$t('goodsPage.package.money1')" show-overflow-tooltip align="center">
              <template slot-scope="scope">{{ (scope.row.materialFee).toFixed(2) }}</template>
          </el-table-column>
          <el-table-column prop="labourFee" :label="$t('goodsPage.package.money2')" show-overflow-tooltip align="center">
              <template slot-scope="scope">{{ (scope.row.labourFee).toFixed(2) }}</template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { orderApi } from '@/api';
import SkuList from './SkuList';
import SkuLineList from './SkuLineList';
import { PACKAGE_TYPE_LIST } from '@/utils/constants';
export default {
  name: 'BusinessOrderInternalViewGoodsInfoTab',
  components: { SkuList, SkuLineList },
  props: {
    innerOrderNo: {
      type: String,
      default: null,
    },
    orderId: {
      type: String,
      default: null,
    },
    hasBtn: {
      type: Boolean,
      default: false,
    },
    orderStatus: {
      type: [Boolean, String],
      default: false,
    },
    businessType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      PACKAGE_TYPE_LIST,
      goodsInfoActiveTab: 'sku',
      goodsInfoActiveTabHistory: new Set(['sku']),
      operationType: null,
    };
  },
  watch: {
    goodsInfoActiveTab(v) {
      this.goodsInfoActiveTabHistory.add(v);
    },
    // orderId变化时，重新渲染LIST
    orderId(v) {
      const temp = this.goodsInfoActiveTabHistory;
      this.goodsInfoActiveTabHistory = new Set();
      this.$nextTick(e => {
        this.goodsInfoActiveTabHistory = temp;
        this.getPackageList()
      });
    },
  },
  mounted() {
    this.operationType = this.$route.query.operationType ? this.$route.query.operationType : null;
  },
  methods: {
    afterFetchOriginalData(data) {
      this.$emit('afterFetchOriginalData', data);
    },
    getPackageList(){
      orderApi.getOrderPackageList({innerOrderNo: this.innerOrderNo}).then(res=>{
        this.PackageVOList = res
      })
    },
    onAction(action) {
      const hasChildren = this.goodsInfoActiveTab == 'sku';
      const THIS = this.goodsInfoActiveTab == 'sku' ? this.$refs.SkuList : this.$refs.SkuLineList;
      const data = THIS.selectedRows;

      /** ***  需要选中项 */
      let itemIds = [];
      let itemLineIds = [];
      // 新的传参方式
      let ITEM_IDS = [];
      if (!data) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }
      if (!hasChildren) {
        itemIds = [];
        itemLineIds = (data || []).map(e => e.id);
        // 只有商品行
        ITEM_IDS = [];
      } else {
        itemIds = (data.parents || []).map(e => e.id);
        itemLineIds = []; // (data.children || []).map(e => e.id);
        // 有商品SKU下挂着商品行
        ITEM_IDS = (data.parents || []).map(e => {
          return {
            id: e.id,
            idList: (data.children || []).filter(ee => ee.BJ_PARENT_ID == e.id).map(ee => ee.id),
          };
        });
      }

      if (!itemIds.length && !itemLineIds.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }

      switch (action) {
        case this.$t('OrdinaryOrderMix.GoodsInfoTab.Pending'): {
          const POST_DATA = {
            innerOrderNo: this.innerOrderNo,
            actionType: '0', // 0-挂起 1-解挂
            itemIds: ITEM_IDS,
            itemLineIds: itemLineIds,
          };
          this.$confirm(this.$t('OrdinaryOrderMix.GoodsInfoTab.suspend'))
            .then(_ => {
              this.suspendOrderByItemLine(POST_DATA);
            })
            .catch(_ => {});
          break;
        }
        case this.$t('OrdinaryOrderMix.GoodsInfoTab.Unhook'): {
          const POST_DATA = {
            innerOrderNo: this.innerOrderNo,
            actionType: '1', // 0-挂起 1-解挂
            itemIds: ITEM_IDS,
            itemLineIds: itemLineIds,
          };

          this.$confirm(this.$t('OrdinaryOrderMix.GoodsInfoTab.cancel'))
            .then(_ => {
              this.suspendOrderByItemLine(POST_DATA);
            })
            .catch(_ => {});
          break;
        }
        case this.$t('OrdinaryOrderMix.GoodsInfoTab.Confirm'): {
          const POST_DATA = {
            innerOrderNo: this.innerOrderNo,
            itemIds: ITEM_IDS,
            itemLineIds: itemLineIds,
          };
          this.$confirm(this.$t('OrdinaryOrderMix.GoodsInfoTab.goods'))
            .then(_ => {
              this.confirmReceiptByItemLineApi(POST_DATA);
            })
            .catch(_ => {});
          break;
        }
        case this.$t('OrdinaryOrderMix.GoodsInfoTab.black'):
          break;
      }
    },
    suspendOrderByItemLine(POST_DATA) {
      orderApi.suspendOrderByItemLine(POST_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$emit('reFresh', this.goodsInfoActiveTab);
          }, 500);
        }
      });
    },
    // 商品级-确认收货
    confirmReceiptByItemLineApi(POST_DATA) {
      orderApi.confirmReceiptByItemLine(POST_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.tab-btns {
  display: inline-block;
  position: absolute;
  right: 60px;
  margin-top: 4px;
  z-index: 1;
}
.goodsTable{
  position: relative;
  z-index: 1;
}
</style>
